import { Box as MuiBox, BoxProps, useTheme } from '@mui/material';
//@ts-ignore
import React from 'react';

type TBoxProps = BoxProps & {
  scrollbar?: 'light' | 'default';
};

export function Box({ children, scrollbar = 'default', sx, ...other }: TBoxProps) {
  const { palette } = useTheme();
  return (
    <MuiBox
      {...other}
      sx={{
        ...sx,
        ...(scrollbar === 'light' && {
          // For browsers other than Firefox
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            background: palette.primary.main,
            borderRadius: '20px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: palette.primary.light,
            cursor: 'pointer',
          },
          // For Firefox
          scrollbarColor: `${palette.primary.main} transparent`,
        }),
      }}
    >
      {children}
    </MuiBox>
  );
}
